module.exports = __webpack_public_path__ + "fonts/medium.767f40f.eot";